<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.74986 17.9994C2.33565 17.9994 1.99986 17.6636 1.99986 17.2494C1.99986 16.8351 2.33565 16.4994 2.74986 16.4994H17.249C17.6632 16.4994 17.999 16.8351 17.999 17.2494C17.999 17.6636 17.6632 17.9994 17.249 17.9994H2.74986Z"
      fill="currentColor"
    />
    <path
      d="M5.99944 2.00049C5.44715 2.00049 4.99944 2.4482 4.99944 3.00049V13.0005C4.99944 13.5528 5.44715 14.0005 5.99944 14.0005H13.9994C14.5517 14.0005 14.9994 13.5528 14.9994 13.0005V3.00049C14.9994 2.4482 14.5517 2.00049 13.9994 2.00049H5.99944Z"
      fill="currentColor"
    />
  </svg>
</template>
